import React from 'react';
import { AuthXService } from '@brg/auth';
import { Spinner } from '@brg/controls';
import { SpinnerWrapper } from './styled';

export class SilentView extends React.Component<any, any> {
    // Данный компонент никогда не должен перерисовываться вне зависимости ни от чего!
    shouldComponentUpdate(nextProps: Readonly<any>, nextState: Readonly<any>, nextContext: any): boolean {
        return false;
    }

    /**
     * При отрисовке компонента
     */
    componentDidMount(): void {
        AuthXService.createUserManager()
            .signinSilentCallback()
            .catch(console.error);
    }

    /**
     * Отрисовка
     */
    render() {
        return <div>
            <span>
                Silent auth callback
            </span>
            <SpinnerWrapper>
                <Spinner size={100} color='silver' width={1.5} />
            </SpinnerWrapper>
        </div>;
    }
}
import React from 'react';
import { AuthXService } from '@brg/auth';
import { Spinner } from '@brg/controls';
import { SpinnerWrapper } from './styled';

export class SilentView extends React.Component<any, any> {
    // Данный компонент никогда не должен перерисовываться вне зависимости ни от чего!
    shouldComponentUpdate(nextProps: Readonly<any>, nextState: Readonly<any>, nextContext: any): boolean {
        return false;
    }

    /**
     * При отрисовке компонента
     */
    componentDidMount(): void {
        AuthXService.createUserManager()
            .signinSilentCallback()
            .catch(console.error);
    }

    /**
     * Отрисовка
     */
    render() {
        return <div>
            <span>
                Silent auth callback
            </span>
            <SpinnerWrapper>
                <Spinner size={100} color='silver' width={1.5} />
            </SpinnerWrapper>
        </div>;
    }
}
